import ShopifySectionsManager from 'shopify-sections-manager';
// import StaticProduct from '../sections/StaticProduct';
import StaticProductReact from '../sections/StaticProductReact';
import ProductFeatures from '../sections/ProductFeatures';
import 'intersection-observer';
import rimg from 'rimg-shopify';

import '../../styles/templates/product.scss';
import StaticExitIntent from '../sections/StaticExitIntent';

const sections = window.shopifySections || new ShopifySectionsManager();

const reloadSection = (sectionId) => {
  const target = document.querySelector(`[data-section-type="${sectionId}"]`)
  if (!target) return;
  const parentTarget = target.parentNode;

  sections._onSectionEvent({
    target: parentTarget,
    detail: {
      sectionId: sectionId
    },
    type: 'shopify:section:unload'
  })
  sections._onSectionEvent({
    target: parentTarget,
    detail: {
      sectionId: sectionId
    },
    type: 'shopify:section:load'
  })
}

export default class ProductPage {
  constructor() {
    this.el = document.body;

    // sections.register('static-product', section => new StaticProduct(section));
    sections.register('static-product-react', section => new StaticProductReact(section));
    sections.register('product-features', section => new ProductFeatures(section));
    sections.register('static-exit-intent', section => new StaticExitIntent(section));

    document.addEventListener('product-change', () => {
      reloadSection('product-features');
      reloadSection('static-exit-intent');
      // sections.register('static-product', section => new StaticProduct(section));
      // sections.register('product-features', section => new ProductFeatures(section));
      // rimg.watch(document.getElementById('shopify-section-static-product'));
      rimg.watch(document.getElementById('shopify-section-product-features'));
      rimg.watch(document.getElementById('shopify-section-static-exit-intent'));
      document.dispatchEvent(new CustomEvent('ga:update'))
    });

    rimg.init();
  }
}

new ProductPage();